export const PROFESSOR_STORE = 'professor';